import type { GroupV1_jsonld_page_read } from '@/features/group-v1/group-v1-type';

import useDynamicPageComponentByType from '@/core/features/a-dynamic-page/hooks/use-dynamic-page-component-by-type';

export function useIsMapBottomSheetInitiallyOpen() {
    const bottomSheetState = useDynamicPageComponentByType<GroupV1_jsonld_page_read>(
        'GroupV1',
        (groupComponent) => groupComponent.meta.style === 'map_bottom_sheet',
    )?.meta.bottomSheetState;

    return ['full', 'half'].includes(bottomSheetState ?? '');
}
